import coworker from '../../@helpers/js/coworker.js';
import { registerTrigger, triggerNamedNotify, subscribeNamedNotify } from '../../@helpers/js/observer.js';

const shopping = { hasSender: false };

export default function(element, { srLabel = 'Bereken uw premie', checkCart = true, apimKey, cartUrl } = {}) {
	if (!element) {
		return;
	}

	let callRefresh = false;
	let topBar = element.closest('.shared-header__top-bar');
	if (topBar) {
		element.classList.remove('t-visuallyhidden');
	}

	registerTrigger('shoppingcart-refresh');
	registerTrigger('shoppingcart-update');

	function processPremium(premie) {
		if (premie && premie !== '0') {
			element.innerHTML = `${premie.replace(/(\d*)/, '€&nbsp;$1') }`;
			if (!topBar) {
				element.classList.remove('t-visuallyhidden');
			}
		} else {
			element.innerHTML = `${srLabel}`;
			if (!topBar) {
				element.classList.add('t-visuallyhidden');
			}
		}
	}

	if (checkCart) {
		subscribeNamedNotify('shoppingcart-update', {
			name: 'shoppingcart-update',
			fn: ({ premie = '', discount = false }) => {
				if (!discount) {
					processPremium(premie);
				} else {
					if (callRefresh && typeof callRefresh === 'function') {
						callRefresh();
					}
				}
			}
		});

		if (!shopping.hasSender) {
			shopping.hasSender = true;

			function refresh({url, key}) {
				return fetch(url, {
					credentials: 'include',
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						'Ocp-Apim-Subscription-Key': key,
					},
				})
				.then(function(response) {
					if (!response.ok) {
						throw new Error(`Sorry, the server response is not correct!`)
					}
					return response.text().then(function(result) {
						return result;
					})
				})
				.catch(function(error) {
					throw new Error(`Sorry, the server response is incorrect`)
				});
			}
			
			const _coworker = coworker(refresh, `check-for-session`);
			
			async function _callbackend({url, key}) {
				try {
					let result;
					if (_coworker) {
						result = await _coworker.sendMessage({url, key});
					} else {
						result = await refresh({url, key});
					}
					return result;
				} catch (error) {
					return null;
				}
			}

			callRefresh = () => _callbackend({url: cartUrl, key: apimKey}).then((premie) => {
				processPremium(premie);
				triggerNamedNotify('shoppingcart-refresh', {
					name: 'shoppingcart-refresh',
					args: {
						premie: premie || '',
					},
				});
			});

			callRefresh();
		} else {
			subscribeNamedNotify('shoppingcart-refresh', {
				name: 'shoppingcart-refresh',
				fn: ({premie = ''}) => processPremium(premie),
			});
		}
	}
}